var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuffer = function SvgBuffer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path922",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M16.173 10.981c4.438 0 8.065-2.17 8.065-4.82 0-2.665-3.627-4.834-8.065-4.834-4.452 0-8.08 2.17-8.08 4.834 0 2.65 3.628 4.82 8.08 4.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path924",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M8.094 5.955v19.9c0 2.664 3.613 4.834 8.079 4.834 4.452 0 8.065-2.17 8.065-4.834V6.285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path926",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.638,
    d: "M16.118 26.733c1.731 0 3.147-1.277 3.147-2.856 0-1.566-1.416-2.843-3.147-2.843-1.745 0-3.16 1.277-3.16 2.843 0 1.579 1.415 2.856 3.16 2.856"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuffer);
export default ForwardRef;